import './bootstrap.config.js';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/styles/bootstrap/index.ts